
// React 
import React, { Component, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Button, } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';
// import ModalRegEmail from './ModalRegEmail';
// import ModalRegComplete from './ModalRegComplete';

//SCSS
import '../../../scss/components/main/footer.scss';
import ModalAuth from './ModalAuth';
import ModalRegister from './ModalRegister';
import CartCtx from '../../CartCtx';

const ProfileHeader = () => {

    const { isShowAuthModal, setIsShowAuthModal } = useContext(CartCtx)

    const [isShowRegister, setIsShowRegister] = useState(false)
    // const [isShowAuth, setIsShowAuth] = useState(false)


    const [inputsData, setInputsData] = useState(null)
    const [authUser, setAuthUser] = useState('')
    const [avatar, setAvatar] = useState('')

    useEffect(() => {
        const fetchInitial = () => {
            if (localStorage.getItem('galaxy-token')) {
                axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/profile`, {
                    jwt: localStorage.getItem('galaxy-token')
                }).then((response) => {
                    setAvatar(response?.data?.data?.info?.icon_url || '')
                    setAuthUser((response?.data?.data?.info?.name || '') + ' ' + (response?.data?.data?.info?.surname || ''))

                }).catch(err => {
                    localStorage.removeItem('galaxy-token')
                    console.error(err)
                })
            }
        }
        fetchInitial()
        fetchInputs()
    }, [])


    const fetchInputs = () => {
        axios.get(`${process.env.REACT_APP_API_BASE}/pages/get-form`).then((response) => {
            if (response.data) {
                setInputsData(response.data)
            }
        }).catch(err => {
            console.error(err)
        })

    }

    const handleShow = () => {
        if (localStorage.getItem('galaxy-token')) {
            axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/profile`, {
                jwt: localStorage.getItem('galaxy-token')
            }).then((response) => {
                handleCloseAuth()
            }).catch(err => {
                console.error(err)
                localStorage.removeItem('galaxy-token')
                setIsShowAuthModal(true)
            })
        } else {
            setIsShowAuthModal(true)
        }
    }
    const handleCloseAuth = () => {
        setIsShowAuthModal(false)
    }
    const handleCloseRegister = () => {
        setIsShowRegister(false)
    }

    const handleRegister = () => {
        setIsShowAuthModal(false)
        setIsShowRegister(true)
    }
    const handleAuth = () => {
        setIsShowAuthModal(true)
        setIsShowRegister(false)
    }

    return (
        <div className="h-profile">
            {
                localStorage.getItem('galaxy-token') ?
                    <div className="avatar">
                        <Link to='/profile' title={authUser}>
                            {
                                avatar ?
                                    <img id='userpic'
                                        src={process.env.REACT_APP_BACKEND + 'users_avatar/' + avatar + '?rng=' + new Date().getTime()}
                                        alt=""
                                        style={{
                                            border: '2px solid #999'
                                        }}
                                    />
                                    :
                                    <img id='userpic' src="/img/avatar-default.svg" alt="" />
                            }
                        </Link>
                    </div>
                    :
                    <Button
                        disabled={!inputsData}
                        className="btn-profile"
                        onClick={handleShow}
                    >
                        <i className="i-profile"></i>
                    </Button>
            }
            <ModalAuth
                handleClose={handleCloseAuth}
                inputsData={inputsData}

                isShow={isShowAuthModal}
                handleRegister={handleRegister}
            />
            <ModalRegister
                isShow={isShowRegister}
                inputsData={inputsData}
                handleClose={handleCloseRegister}
                handleAuth={handleAuth}
            />
        </div>
    )
}

export default ProfileHeader